// API base URL selection and keys (mirrors webapp semantics)

export const BASE_URL_KEY = 'base_url';
export const LOCALHOST_BASE_URL = 'http://localhost:9000';
export const REMOTE_BASE_URL =
  (import.meta.env.VITE_REMOTE_BASE_URL as string | undefined) ?? 'https://kong.dev.planera.io';

export const BASE_URL = (): string => {
  const saved = localStorage.getItem(BASE_URL_KEY);
  return saved && saved.length > 0 ? saved : REMOTE_BASE_URL;
};
